import * as React from 'react';

const SvgRoaming = (props) => (
  <svg
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='m21.516 3.947-12.04 4c-8.093 2.706-8.093 7.12 0 9.813l3.574 1.187 1.186 3.573c2.694 8.093 7.12 8.093 9.814 0l4.013-12.027c1.787-5.4-1.147-8.346-6.547-6.546Zm.427 7.173-5.067 5.093c-.2.2-.453.294-.706.294a.989.989 0 0 1-.707-.294 1.006 1.006 0 0 1 0-1.413l5.067-5.093a1.006 1.006 0 0 1 1.413 0 1.006 1.006 0 0 1 0 1.413Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgRoaming;
